import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearch } from "hooks/useSearch";

import { Grid, TextField, Autocomplete } from "@mui/material";
import RegularButton from "components/CustomButtons/Button";


import { CAPTURES_PHRASE } from "./config";
import {
  selectRouteCycle,
  fetchCloseCycle,
  fetchSyncCycle
} from "redux/actions/buildings/captures/capturesActions";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import SyncIcon from "@mui/icons-material/Sync";
import { useToggle } from "hooks/useToggle";
import { Modal } from "components/Modal/Modal";

export const CaptureTableInputs = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const [closeModal, setCloseModal] = useToggle();

  const { isLoadingComp } = useSelector(state => state.search);

  const { routeCycles, routeCycleSelected, station } = useSelector(
    state => state.captures
  );

  const handleChangeRouteCycle = (e, v) => {
    dispatch(selectRouteCycle(v));
  };

  const handleCloseCycle = e => {
    e.preventDefault();

    if (!routeCycleSelected) {
      setSnackbar(CAPTURES_PHRASE.page.table.header.snackBar);
      return;
    }

    dispatch(fetchCloseCycle(routeCycleSelected.id, () => setCloseModal()));
  };

  const handleSyncCycle = e => {
    e.preventDefault();

    if (!routeCycleSelected) {
      setSnackbar(CAPTURES_PHRASE.page.table.header.snackBar);
      return;
    }

    dispatch(fetchSyncCycle(routeCycleSelected.id));
  };

  useEffect(() => {
    dispatch(selectRouteCycle(null));
  }, [station])

  return (
    <>
      <Grid item xs={12} sm={5} >
        <Autocomplete
          options={routeCycles}
          getOptionLabel={option => option.label}
          disabled={routeCycles?.length === 0}
          value={routeCycleSelected}
          renderInput={params => (
            <TextField
              {...params}
              name="routeCycles"
              label={CAPTURES_PHRASE.page.table.header.dropdown.label}
              variant="outlined"
              size="small"
            />
          )}
          fullWidth
          onChange={(e, v) => handleChangeRouteCycle(e, v)}
          noOptionsText={
            CAPTURES_PHRASE.page.table.header.dropdown.noOptions
          }
        />
      </Grid>
      <Grid item xs={12} sm={1}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
        <RegularButton
          justIcon
          round
          color="warning"
          disabled={isLoadingComp?.fetchCloseCycle}
          onClick={setCloseModal}
          tooltip={CAPTURES_PHRASE.page.table.header.closeButton}
        >
          <TaskAltIcon style={{ margin: 0 }} />
        </RegularButton>
        <RegularButton
          justIcon
          round
          color="success"
          disabled={isLoadingComp?.fetchSyncCycle}
          onClick={handleSyncCycle}
          tooltip={CAPTURES_PHRASE.page.table.header.syncButton}
        >
          <SyncIcon style={{ margin: 0 }} />
        </RegularButton>
      </Grid>
      <Modal
        isOpen={closeModal}
        handleClose={setCloseModal}
        textButton1={CAPTURES_PHRASE.modal.actions.submit}
        textButton2={CAPTURES_PHRASE.modal.actions.cancel}
        actionFunction1={setCloseModal}
        actionFunction2={handleCloseCycle}
        textContent={CAPTURES_PHRASE.modal.content.close}
        isDisabled={isLoadingComp.loadingFile}
      />
    </>
  );
};
